import { generateAPI } from "../api.generator";

export const getInsights = generateAPI<
  {},
  {
    pageviews: number;
    rsvps: number;
  }
>("get", "wedding/insights");
